import styled from "styled-components";

export const LegalContainer = styled.div`
  color: #ffffff;
  font-size: 14px;
  padding: 8px;
  text-align: left;
  background-color: #191919;
`;

export const LegalTitle = styled.h1`
  font-size: 22px;
  margin: 12px 0;
`;

export const LegalSectionTitle = styled.h2`
  font-size: 16px;
  margin: 14px 0;
`;

export const LegalSectionBlock = styled.p`
  margin: 10px;
`;

export const LegalList = styled.ul`
  margin: 10px;
`;

export const LegalOrderedList = styled.ol`
  margin: 10px;
`;

export const LegalListItem = styled.li`
  margin: 0 20px;
  list-style-type: disc;
`;
